Vendd.Scripts.load(function () {

    var Vendd = window.Vendd || {};

    var toolbarContainer = function (element, definition) {

        Vendd.inlineEdit.containerControlBase.apply(this, [element, definition]);

    };
    toolbarContainer.prototype = Object.create(Vendd.inlineEdit.containerControlBase.prototype);
    toolbarContainer.prototype.name = 'toolbarContainer';

    toolbarContainer.prototype.render = function () {

        var self = this;

        return Vendd.Promises.GetOrDefault(function() { return Vendd.inlineEdit.containerControlBase.prototype.render.apply(self); })
            .then(function() { self.element.addClass(self.definition.cssClasses); });

    };

    Vendd.inlineEdit.toolbarContainer = toolbarContainer;

});